/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage}  from "react-intl";
import { Link } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import PackagesCarousel from "./packagesCarousel/index.js";
import SinglePackage from "./singlePackage/index.js";
import { ReactComponent as HelpIcon } from "../../resources/images/aa-help-active.svg";
import { ReactComponent as File } from "../../resources/images/file-02.svg";
import { ReactComponent as FileCorner } from "../../resources/images/file-corner.svg";
import { ReactComponent as ArrowRightIcon } from "../../resources/images/arrow-right.svg";
import { AADVANTAGE_PROGRAM_DATA } from "constants/appConstants.js";
import { useHomepageService } from "services/homepageService.js";

/* Components */

/* Styles */
import styles from "./styles.js"

const AAdvantagePass = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const { staticContent } = useHomepageService();

  return (
    <div>
      <h1 className={classes.title}>
        <FormattedMessage id="aadvantage.pass.title"/>
      </h1>
      <p className={classes.subtitle}>
        <FormattedMessage id="aadvantage.pass.subtitle"/>
      </p>
      {/* Multiple packages in the future, for nov 2025 launch we display only one package */}
      {/* To do: add translations for multiple packages view (structure might change in the future, left data hardcoded) */}
      {/* <PackagesCarousel /> */}
      <SinglePackage />
      <p className={classes.descriptiveText}>
        <FormattedMessage id="aadvantage.pass.login.desc"/>
      </p> 
      <Link to={AADVANTAGE_PROGRAM_DATA.loginUrl} target="_blank" className={classes.link}>
        <FormattedMessage id="aadvantage.pass.login"/>
        <ArrowRightIcon />
      </Link>
      <hr className={classes.divider} />
      <div className={classes.footerItemWrapper}>
        <div>
          <HelpIcon />
        </div>
        <div className={classes.footerItem}>
          <h6>
            <FormattedMessage id="aadvantage.pass.needhelp"/>
          </h6>
          <p>
            <FormattedMessage id="aadvantage.pass.needhelp.desc"/>
          </p>
          {/* todo: add link when available */}
          <Link to={staticContent?.aadvantagePassGuideLink} target="_blank" className={classes.link}>
            <FormattedMessage id="aadvantage.pass.view.guide"/>
            <ArrowRightIcon />
          </Link>
        </div>
      </div>
      <hr className={classes.divider} />
      <div className={classes.footerItemWrapper}>
        <div>
          <FileCorner />
        </div>
        <div className={classes.footerItem}>
          <h6>
            <FormattedMessage id="aadvantage.pass.questions"/>
          </h6>
          <p className={classes.descText}>
            <FormattedMessage id="aadvantage.pass.faq"/>
          </p>
          <p>
            <FormattedMessage id="aadvantage.pass.callus"/> <span className={classes.phoneNumber}>{AADVANTAGE_PROGRAM_DATA.contactNumber}</span>
          </p>
          <p>
            <FormattedMessage id="aadvantage.pass.callus.program"/>
          </p>
          <Link to={AADVANTAGE_PROGRAM_DATA.faqUrl} target="_blank" className={classes.link}>
            <FormattedMessage id="aadvantage.pass.explore.faq"/>
            <ArrowRightIcon />
          </Link>
        </div>
      </div>
      <hr className={classes.divider} />
      <div className={classes.footerItemWrapper}>
        <div>
          <File />
        </div>
        <div className={classes.footerItem}>
          <Link to={AADVANTAGE_PROGRAM_DATA.tandcUrl} target="_blank" className={classes.link2}>
            <FormattedMessage id="aadvantage.pass.tandc"/>
            <ArrowRightIcon />
          </Link>
        </div>
      </div>
      <hr className={classes.divider} />
      <p className={classes.starText}>
        <FormattedMessage id="aadvantage.pass.starnote"/>
      </p> 
    </div>
  )
};

export default AAdvantagePass;
